import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const createPullRequestDropdownContentEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-dev-panel-create-pullrequest-dropdown" */ './index'),
	),
	getPreloadProps: () => ({}),
});
